<template>
  <div>
    <v-dialog v-model="active" persistent width="500">
      <v-card>
        <v-card-title class="headline" primary-title>
          Geometrisk operasjon
        </v-card-title>

        <v-card-text>
          <p class="caption">
            Dette verktøyet lar deg utføre en rekke ulike geometriske
            operasjoner på tegnelaget ditt. Velg en operasjon i menyen under,
            fyll ut de påkrevde feltene og klikk kjør. Resultatet fra
            operasjonen vil dukke opp i kartlagslisten som et eget tegnelag.
          </p>
          <v-select
            box
            label="Velg operasjon"
            :return-object="true"
            :items="geometryOperationsLocal"
            item-text="name"
            v-model="selectedGeometryOperation"
          ></v-select>
          <div v-if="selectedGeometryOperation">
            <v-layout
              column
              v-for="parameter in selectedGeometryOperation.parameters"
              :key="parameter.name"
            >
              <v-layout column v-if="parameter.type == 'geometry'">
                <v-select
                  box
                  v-if="selectedGraphicsLayer"
                  :label="parameter.description"
                  :multiple="parameter.multiple"
                  item-value="uid"
                  :return-object="true"
                  v-model="parameter.value"
                  :items="selectedGraphicsLayer.graphics"
                  item-text="attributes.name"
                ></v-select>
              </v-layout>

              <v-layout column v-if="parameter.type == 'number'">
                <v-text-field
                  type="number"
                  box
                  :label="parameter.name"
                  v-model="parameter.value"
                  :placeholder="parameter.name"
                >
                </v-text-field>
              </v-layout>

              <v-layout column v-if="parameter.type == 'select'">
                <v-select
                  box
                  :label="parameter.name"
                  v-model="parameter.value"
                  :items="parameter.items"
                >
                </v-select>
              </v-layout>
            </v-layout>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="emitDialogClosedEvent">
            Avbryt
          </v-btn>
          <v-btn flat color="primary" @click="runGeometryCalculation">
            Kjør
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";

export default {
  name: "GeometryCalculatorDialog",
  computed: {
    ...mapState(["geometryOperations", "mapProfiles"])
  },
  mixins: [MappingMixin],
  data: () => ({
    dialog: false,
    allAddedGraphicLayers: [],
    selectedGeometryOperation: null,
    geometryOperationsLocal: null
  }),
  props: {
    active: Boolean,
    selectedGraphicsLayer: Object
  },
  watch: {
    active: function() {
      this.allAddedGraphicLayers = this.mapProfiles.filter(profile => {
        return profile.type === "graphicsLayer";
      });

      this.allAddedGraphicLayers.forEach(layer => {
        let mapLayer = this.$theMapObject.findLayerById(layer.id);
        layer.graphics = mapLayer.graphics.items;
      });
    }
  },
  methods: {
    ...mapActions(["setSnack", "addGraphicsLayer"]),
    emitDialogClosedEvent() {
      this.$emit("close-dialog");
    },
    runGeometryCalculation() {
      loadModules([
        "esri/geometry/geometryEngine",
        "esri/layers/GraphicsLayer",
        "esri/Graphic"
      ]).then(([geometryEngine, GraphicsLayer, Graphic]) => {
        let geometryFunction =
          geometryEngine[this.selectedGeometryOperation.function];

        let args = [];

        for (
          let i = 0;
          i < this.selectedGeometryOperation.parameters.length;
          i++
        ) {
          let parameter = this.selectedGeometryOperation.parameters[i];
          let value;
          if (parameter.type === "geometry") {
            if (parameter.multiple) {
              value = [];
              parameter.value.forEach(graphic => {
                value.push(graphic.geometry);
              });
            } else {
              value = parameter.value.geometry;
            }
          } else if (parameter.type === "number") {
            value = [parseInt(parameter.value)];
          } else {
            value = parameter.value;
          }

          args.push(value);
        }

        let results = geometryFunction.apply(this, args);

        let layerId = this.selectedGraphicsLayer.id + new Date().getTime();
        let newGraphicsLayer = new GraphicsLayer({
          id: layerId
        });
        this.$theMapObject.add(newGraphicsLayer);
        this.addGraphicsLayer(layerId);
        this.addMapProfile({
          id: layerId,
          showInfoMenu: false,
          appTitle:
            "Resultat " + this.selectedGeometryOperation.name.toLowerCase(),
          Temaforklaring: ""
        });

        if (!(results instanceof Array)) {
          results = [results];
        }

        results.forEach((result, index) => {
          newGraphicsLayer.add(
            new Graphic({
              geometry: result,
              attributes: {
                id: index,
                name:
                  this.selectedGeometryOperation.name.toLowerCase() +
                  " " +
                  index
              },
              symbol: this.getDefaultSymbolBasedOnGeometryType(result)
            })
          );
        });

        this.emitDialogClosedEvent();
      });
    }
  },
  mounted() {
    this.geometryOperationsLocal = JSON.parse(
      JSON.stringify(this.geometryOperations)
    );
  }
};
</script>

<style scoped></style>
